import { NationalMenuTileData } from './types';

const pasta: NationalMenuTileData[] = [
  {
    id: 'pasta1',
    name: 'Oven-Baked Chicken Alfredo Pasta',
    mobileImageUrl: '/images/nationalMenu/pasta/National_Pasta_Chicken_Alfredo.jpg',
    desktopImageUrl: '/images/nationalMenu/pasta/National_Pasta_Chicken_Alfredo.jpg',
    productDescription: 'You can\'t go wrong with this classic combination of our new creamy Alfredo sauce, grilled chicken, cheese, shredded Parmesan, and Parmesan-oregano seasoning. Includes 5 breadsticks.',
    priority: 0,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'pasta2',
    name: 'Oven-Baked Italian Meats Pasta',
    mobileImageUrl: '/images/nationalMenu/pasta/National_Pasta_Italian_Meats.jpg',
    desktopImageUrl: '/images/nationalMenu/pasta/National_Pasta_Italian_Meats.jpg',
    productDescription: 'Fill up on this savory new recipe that\'s packed with sweet tomato sauce, pepperoni, Italian sausage, cheese, shredded Parmesan, and Parmesan-oregano seasoning. Includes 5 breadsticks.',
    priority: 1,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'pasta3',
    name: 'Oven-Baked Cheesy Alfredo Pasta',
    mobileImageUrl: '/images/nationalMenu/pasta/National_Pasta_Cheesy_Alfredo.jpg',
    desktopImageUrl: '/images/nationalMenu/pasta/National_Pasta_Cheesy_Alfredo.jpg',
    productDescription: 'A cheese lover\'s dream featuring our new creamy Alfredo sauce, cheese, shredded Parmesan, and Parmesan-oregano seasoning. Includes 5 breadsticks.',
    priority: 2,
    vegetarian: true,
    handleClick: () => {}
  },
  {
    id: 'pasta4',
    name: 'Oven-Baked Veggie Pasta',
    mobileImageUrl: '/images/nationalMenu/pasta/National_Pasta_Veggie.jpg',
    desktopImageUrl: '/images/nationalMenu/pasta/National_Pasta_Veggie.jpg',
    productDescription: 'A flavorful combo of sweet tomato sauce, green peppers, onions, tomatoes, black olives, cheese, shredded Parmesan and cheesy garlic Hut Dust seasoning. Includes 5 breadsticks.',
    priority: 3,
    vegetarian: true,
    handleClick: () => {}
  }
];

export default pasta;
